import * as yup from "yup";
import { TFunction } from "i18next";
import { BusinessPurchaseOrder } from "../../../../graphql/types/models/business";

export default function editPurchaseOrderSchema(t: TFunction) {
  return yup.object().shape<BusinessPurchaseOrder>({
    // richOrderTerms: yup.object().optional(),
  });
}
